/**
* Custom Toast utility for Worthly
* Styled to match iOS-style foreground push notification banner
*/
import { toast as sonnerToast } from "sonner";

// Shared frosted-glass wrapper style (mirrors NotificationContext toast)
const bannerStyle = {
  background: 'rgba(255, 255, 255, 0.72)',
  WebkitBackdropFilter: 'saturate(180%) blur(20px)',
  backdropFilter: 'saturate(180%) blur(20px)',
  borderRadius: '16px',
  padding: '14px 16px',
  boxShadow: '0 2px 16px rgba(0,0,0,0.12), 0 0 0 0.5px rgba(0,0,0,0.06)',
  border: 'none',
};

// Reusable toast layout matching push notification banner structure
const ToastLayout = ({ icon, title, description }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <div style={{ fontSize: '24px', flexShrink: 0, lineHeight: 1 }}>{icon}</div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
        <div style={{ fontSize: '15px', fontWeight: 600, color: '#000000', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</div>
        <div style={{ fontSize: '13px', color: 'rgba(0,0,0,0.4)', flexShrink: 0, marginLeft: '8px' }}>now</div>
      </div>
      {description && (
        <div style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)', lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{description}</div>
      )}
    </div>
  </div>
);

// Custom toast functions
export const customToast = {
  success: (title, description) => {
    return sonnerToast.custom(
      () => <ToastLayout icon="✅" title={title} description={description} />,
      { duration: 3000, style: bannerStyle }
    );
  },

  error: (title, description) => {
    return sonnerToast.custom(
      () => <ToastLayout icon="❌" title={title} description={description} />,
      { duration: 4000, style: bannerStyle }
    );
  },

  celebration: (title, description) => {
    return sonnerToast.custom(
      () => <ToastLayout icon="🎉" title={title} description={description} />,
      { duration: 4000, style: bannerStyle }
    );
  },

  info: (title, description) => {
    return sonnerToast.custom(
      () => <ToastLayout icon="ℹ️" title={title} description={description} />,
      { duration: 2500, style: bannerStyle }
    );
  },
};

export default customToast;
